(() => {
  const key = 'sinroom.age-confirmed.until.v2';
  const legacy = 'sinroom.age-confirmed.v1';
  const duration = 24 * 60 * 60 * 1000;
  const gate = document.querySelector('#age-gate');
  if (!gate) return;
  let memoryUntil = 0, timer;
  const valid = until => Number.isFinite(until) && until > Date.now() && until - Date.now() <= duration;
  const remove = (storage, name) => { try { window[storage].removeItem(name); } catch {} };
  const save = until => {
    memoryUntil = until;
    try { localStorage.setItem(key, String(until)); remove('sessionStorage', key); }
    catch { try { sessionStorage.setItem(key, String(until)); } catch {} }
  };
  const read = () => {
    let found = 0, sawTimestamp = false;
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        const raw = window[name].getItem(key);
        if (raw !== null) {
          sawTimestamp = true;
          const until = Number(raw);
          if (valid(until)) found = Math.max(found, until);
          else remove(name, key);
        }
      } catch {}
    }
    // One-time migration of a genuine pre-release tab declaration. Never renew
    // an expired timestamp from a stale legacy flag.
    let old = false;
    try { old = sessionStorage.getItem(legacy) === 'yes'; } catch {}
    remove('sessionStorage', legacy);
    if (!found && !sawTimestamp && old) { found = Date.now() + duration; save(found); }
    return found || (valid(memoryUntil) ? memoryUntil : 0);
  };
  const unlock = () => {
    document.documentElement.classList.remove('age-pending');
    if (gate.open) gate.close();
  };
  const check = () => {
    clearTimeout(timer);
    const until = read();
    if (until) {
      unlock();
      timer = setTimeout(check, Math.max(1, until - Date.now()));
    } else {
      memoryUntil = 0;
      document.documentElement.classList.add('age-pending');
      if (!gate.open) gate.showModal();
    }
  };
  gate.addEventListener('cancel', event => event.preventDefault());
  gate.querySelector('[data-age-enter]').addEventListener('click', () => {
    save(Date.now() + duration);
    check();
    const target = document.querySelector('main');
    if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  });
  gate.querySelector('[data-age-leave]').addEventListener('click', () => {
    memoryUntil = 0;
    clearTimeout(timer);
    for (const name of ['localStorage', 'sessionStorage']) remove(name, key);
    remove('sessionStorage', legacy);
    location.replace('about:blank');
  });
  addEventListener('pageshow', check);
  addEventListener('storage', event => { if (event.key === key || event.key === null) { memoryUntil = 0; check(); } });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
  check();
})();
